import { apiHelpers } from './api';
import { InitiatoryInstructionItem, ApiResponse, InitiatoryInstructionItemFormData, InitiatoryInstructionItemList } from '../types/models';
import { convertToUtcDate } from '../utils/dateUtils';

export class InitiatoryInstructionItemService {
  // Получить все вводные инструктажи (упрощенная версия для списка)
  static async getAll(): Promise<ApiResponse<InitiatoryInstructionItemList[]>> {
    return apiHelpers.get<InitiatoryInstructionItemList[]>(`/InitiatoryInstructionItem/GetAll`);
  }

  // Получить вводный инструктаж по ID
  static async getById(id: number): Promise<ApiResponse<InitiatoryInstructionItem>> {
    return apiHelpers.get<InitiatoryInstructionItem>(`/InitiatoryInstructionItem/Get?id=${id}`);
  }

  // Получить вводные инструктажи по сотруднику (упрощенная версия для списка)
  static async getByEmployee(employeeId: number): Promise<ApiResponse<InitiatoryInstructionItemList[]>> {
    return apiHelpers.get<InitiatoryInstructionItemList[]>(`/InitiatoryInstructionItem/GetByEmployee?employeeId=${employeeId}`);
  }

  // Создать новый вводный инструктаж
  static async create(data: InitiatoryInstructionItemFormData): Promise<ApiResponse<InitiatoryInstructionItem>> {
    const utcData = {
      ...data,
      date: convertToUtcDate(data.date),
    };
    return apiHelpers.post<InitiatoryInstructionItem>('/InitiatoryInstructionItem/Create', utcData);
  }

  // Обновить вводный инструктаж
  static async update(id: number, data: InitiatoryInstructionItemFormData & { id: number }): Promise<ApiResponse<void>> {
    const utcData = {
      ...data,
      date: convertToUtcDate(data.date),
    };
    return apiHelpers.put<void>(`/InitiatoryInstructionItem/Update/${id}`, utcData);
  }

  // Удалить вводный инструктаж
  static async delete(id: number): Promise<ApiResponse<void>> {
    return apiHelpers.delete<void>(`/InitiatoryInstructionItem/Delete/${id}`);
  }
}
